import React from "react"
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  Paper,
} from "@mui/material"
import { styled } from "@mui/material/styles"
import PropTypes from "prop-types"
import { useTranslation, Trans } from "react-i18next"

const OrangeTile = ({ name, url, description }) => (
  <Paper
    sx={{
      backgroundColor: "#e6e7e8",
      width: 300,
      height: 250,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: 2,
    }}
  >
    <Typography
      component={Box}
      variant="body"
      fontWeight={500}
      textAlign="justify"
    >
      {description}
    </Typography>
    <Button variant="contained" href={url} target="_blank" fullWidth>
      {name}
    </Button>
  </Paper>
)
OrangeTile.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}

const LanguageToggle = styled(ToggleButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  "&.Mui-selected, &.Mui-selected:hover": {
    color: "white",
    backgroundColor: theme.palette.primary.main,
  },
}))
const PrivacyPage = () => {
  const { t, i18n } = useTranslation()

  document.title = `The Home Depot, Inc. - ${t("privacyPolicy.headerText")}`

  const handleLangChange = (event, newLang) => {
    if (newLang !== null) {
      i18n.changeLanguage(newLang)
    }
  }

  return (
    <Box>
      <AppBar position="static" sx={{ backgroundColor: "#222222" }}>
        <Toolbar>
          <img
            src="/THD_Logo.jpg"
            width="45"
            height="45"
            style={{ margin: "7px 0px" }}
            alt="The Home Depot"
          />
          <Box sx={{ flexGrow: 1 }} mx={1}>
            <Typography fontSize={20} textAlign="center">
              {t("privacyPolicy.headerText")}
            </Typography>
          </Box>
          <Typography variant="h6" textAlign="center" color="aliceblue">
            <ToggleButtonGroup
              size="small"
              value={i18n.language}
              exclusive
              onChange={handleLangChange}
              aria-label="text alignment"
            >
              <LanguageToggle value="en" aria-label="Language selector English">
                EN
              </LanguageToggle>
              <LanguageToggle value="fr" aria-label="Language selector French">
                FR
              </LanguageToggle>
            </ToggleButtonGroup>
          </Typography>
        </Toolbar>
      </AppBar>
      <Grid container rowGap={5} my={5}>
        <Grid
          container
          item
          sx={12}
          sm={6}
          justifyContent="center"
          alignItems="center"
        >
          <OrangeTile
            name="U.S.A"
            url={t("privacyPolicy.usUrl")}
            description={<Trans i18nKey="privacyPolicy.usDesc" />}
          />
        </Grid>
        <Grid
          container
          item
          sx={12}
          sm={6}
          justifyContent="center"
          alignItems="center"
        >
          <OrangeTile
            name="CANADA"
            url={t("privacyPolicy.caUrl")}
            description={<Trans i18nKey="privacyPolicy.caDesc" />}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default PrivacyPage
